import * as Icons from "lucide-react";

import styles from "./custom-select-actions.module.scss";

const VARIANT_CLASS = {
	primary: styles.actionPrimary,
	info: styles.actionInfo,
	warning: styles.actionWarning,
};

const CustomSelectActions = ({ actions = [], iconMap = {} }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.actions}>
				{actions.map((action) => {
					const Icon = iconMap[action.icon] || Icons.SquareEqual;
					const variantClass = VARIANT_CLASS[action.variant] || "";
					return (
						<div key={action.label} className={`${styles.action} ${variantClass}`} onClick={action.onClick}>
							<Icon size={16} className={styles.icon} />
							<span>{action.label}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default CustomSelectActions;
